import React from 'react';
import classnames from 'classnames';
import { twMerge } from 'tailwind-merge';

const Valuation = ({ mark, type, className, onClick }) => {
	const cls = twMerge(
		'h-7 w-7 flex items-center justify-center font-bold text-sm border border-neutral-200 dark:border-neutral-700 dark:text-white text-neutral-800 rounded-lg transition-colors overflow-hidden',
		type === 'active' && 'border-indigo-500 dark:border-indigo-500',
		type === 'finished' && 'border-amber-500 dark:border-amber-500',
		onClick && 'hover:bg-neutral-50 hover:dark:bg-neutral-700 cursor-pointer transition-colors',
		className
	);

	return (
		<div className={cls} onClick={onClick}>
			{mark}
		</div>
	);
};

export default Valuation;